import { categories } from "../mock";

const CategoryCard = ({ item }) => (
  <div className="buying-card">
    <img src={item.image} alt={item.name} className="b-img" loading="lazy" />
    <h4>{item.name}</h4>
    <div className="buying-meta">
      <span>{item.tagline}</span>
    </div>
  </div>
);

const BuyingSection = () => (
  <section className="ws-buying" id="categorieen">
    <span className="ws-tag" style={{ margin: "0 auto 18px", display: "flex", width: "fit-content" }}>
      <span className="dot" />CATEGORIEËN
    </span>
    <h2>Ons assortiment</h2>
    <div className="marquee">
      <div className="buying-track">
        {[...categories, ...categories].map((item, i) => (
          <CategoryCard key={i} item={item} />
        ))}
      </div>
    </div>
  </section>
);

export default BuyingSection;
